/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InlineEditDropdownDirective {
    public restrict = 'E';
    public scope;
    public template;

    public currentValue;

    constructor(private $timeout: any) {
        this.restrict = 'E';
        this.scope = {
            options: '=',
            value: '=',
            saveFunc: '&?',
            changeFunc: '&?',
            label: '@?',
            canEdit: '=?'
        };

        this.template = `             
            <md-input-container class="w-100">
                <label>{{label}}</label>
                <md-select class="lh-initial capital-text", ng-model="value", ng-click="edit()", ng-change="change()", ng-disabled="canEdit == false">
                    <md-option class="capital-text" ng-repeat="x in options track by $index" ng-value="x">
                        {{x}}
                    </md-option>
                </md-select>
            </md-input-container>
        `;

    }


    public link($scope: any, $element: any, attrs: any): any {
        // $element.addClass('inline-edit-dropdown');
        // $scope.editing = false;

        if ($scope.value === '---') {
            $scope.value = undefined;
        }

        $scope.change = function (): any {
            if ($scope.changeFunc !== undefined) {
                var changeObj: any = {
                    model: $scope.value
                };
                $scope.changeFunc({args: changeObj});
            }
            $scope.doneEdit();
        };

        $scope.edit = function (): any {
            //$scope.editing = true;
            this.currentValue = $scope.value;
            // $element.addClass('active');
            // $element.addClass('');
        };

        $scope.doneEdit = function (): any {
            // $scope.editing = false;
            var newValue: any = $scope.value;
            // $element.removeClass('active');
            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };
            if ($scope.saveFunc !== undefined) {
                $scope.saveFunc({args: saveObj});
            }
        };

        $scope.undo = function (): any {
            // $element.removeClass('active');
            $scope.value = this.currentValue;
        };
    }

    public static DirectiveFn($timeout: any): InlineEditDropdownDirective {
        return new InlineEditDropdownDirective($timeout);
    }
}

InlineEditDropdownDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('inlineEditDropdown', InlineEditDropdownDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/inline_edit_dropdown.directive.ts